import type { HGGetClubTournStructuresReply } from '@ps/web-shared-api-types/v0/SwHomeGames';
import { useIntl } from 'react-intl';

import { HandTypeTranslations } from '@swf/poker';

import { TXTCLI_H_L } from './useGetGameOptions.messages.json';

const useGetGameOptions = (structures: HGGetClubTournStructuresReply | undefined) => {
  const { formatMessage } = useIntl();
  if (!structures) {
    return {
      handTypeOptions: []
    };
  }

  const handTypeOptions = structures.gameStructures?.map(({ handType, hiLo }) => {
    if (hiLo) {
      return {
        text: `${formatMessage(HandTypeTranslations[handType as string])} ${formatMessage(
          TXTCLI_H_L
        )}`,
        value: JSON.stringify({ handType, isHiLo: true })
      };
    }

    return {
      text: formatMessage(HandTypeTranslations[handType as string]),
      value: JSON.stringify({ handType, isHiLo: false })
    };
  });

  if (handTypeOptions && handTypeOptions?.length > 0) {
    return { handTypeOptions };
  }

  return {
    handTypeOptions: []
  };
};

export default useGetGameOptions;
